import React from 'react';
import { Routes, Route, useLocation } from "react-router-dom";

import { AnimatePresence } from 'framer-motion';

import { AuthProvider, ThemeProvider, NotiProvider } from './providers';

import NoAuthLayout from './layouts/no-auth';
import AuthLayout from './layouts/auth';

import {
  ApplicationsPage,
  ClientsPage,
  DashboardPage,
  DevicesPage,
  LoginPage,
  SignupPage,
  NetworksConfigurationPage
} from './pages';

import NotFoundPage from './pages/error/notFound';

const App: React.FC = () => {
  const location = useLocation();
  return (
    <ThemeProvider>
      <AuthProvider>
        <NotiProvider>
          <AnimatePresence mode="wait" initial={false}>
            <Routes location={location} key={location.pathname}>
              
              <Route element={<NoAuthLayout />}>
              
                <Route path="/" element={<LoginPage />} />
                <Route path="/sign-up" element={<SignupPage />} />                
              </Route>              

              <Route element={<AuthLayout />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/devices" element={<DevicesPage />} />
                <Route path="/clients" element={<ClientsPage />} />
                <Route path="/applications" element={<ApplicationsPage />} />
                <Route path="/networks-configuration" element={<NetworksConfigurationPage />} />
              </Route>

              <Route path="*" element={<NotFoundPage />} />

            </Routes>
          </AnimatePresence>
        </NotiProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App;
